import { render, staticRenderFns } from "./carrello.vue?vue&type=template&id=5f47eab4&"
import script from "./carrello.vue.ts?vue&type=script&lang=ts&"
export * from "./carrello.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports